import { FC, HTMLProps } from 'react';

export const StarIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.0482 3.92707C9.34755 3.00576 10.651 3.00576 10.9503 3.92707L12.0199 7.21886C12.1538 7.63089 12.5377 7.90985 12.9709 7.90985H16.4321C17.4009 7.90985 17.8036 9.14946 17.0199 9.71886L14.2198 11.7533C13.8693 12.0079 13.7226 12.4593 13.8565 12.8713L14.926 16.1631C15.2254 17.0844 14.1709 17.8506 13.3872 17.2812L10.587 15.2467C10.2366 14.9921 9.76195 14.9921 9.41147 15.2467L6.6113 17.2812C5.82758 17.8506 4.7731 17.0844 5.07246 16.1631L6.14202 12.8713C6.2759 12.4593 6.12924 12.0079 5.77875 11.7533L2.97858 9.71886C2.19487 9.14946 2.59765 7.90985 3.56637 7.90985H7.02757C7.4608 7.90985 7.84475 7.63089 7.97863 7.21886L9.0482 3.92707Z"
        fill="currentColor"
      />
    </svg>
  );
};
